import { Collapse,Tabs,  Button, Spin } from 'antd';
import { useEffect, useState } from 'react';
import CounterParty from './Model/CounterParty';
import EsignStatus from './Model/EsignStatus';
import fetchWithAuth from '../../utils/customFetch';
import { RightOutlined } from '@ant-design/icons';
import axiosInstance from '../../utils/axiosInstance';


const { Panel } = Collapse;
const { TabPane } = Tabs;

const EsignAccordion = ({ id }) => {
  const [activeKey, setActiveKey] = useState("1");
  const [isLoading, setIsLoading] = useState(false);
  const [signuluResponse, setSignuluResponse] = useState({});
  const onCloseCounterParty = () => setActiveKey(activeKey === '2' ? null : '2');

  const handleEsignStatus = async () => {
    setIsLoading(true);
    console.log("heyyy")
    try {
        const response = await axiosInstance.post(`/esign/esign_document_status/`, { agreement_id: id })
      // const res = await fetchWithAuth({
      //   method: 'POST',
      //   endpoint: '/api/v1/esign/esign_document_status/',
      //   data: { agreement_id: id },
      // });
      // const response = {}
      // response.data = res
      console.log(response)
      if (response && response?.data) {
        const tempResponse = response?.data;
        console.log('response,res inside if', tempResponse.recipients, tempResponse.recepients, tempResponse)
        const recipients = tempResponse.recipients.map((recipient) => {
          console.log(recipient, 'recipient')
          return {
            fullName: recipient.FullName,
            email: recipient.EmailAddress,
            signatureImage: recipient.SignatureUpload,
            status: recipient.StatusCode,
          };
        });

        // };
        console.log(recipients, '001')

        setSignuluResponse({
          recepients: recipients,
          addComments: tempResponse.addComments,
          senderName: tempResponse.senderName,
          statusCode: tempResponse.statusCode,
          expirationDate: tempResponse.expirationDate,
          fileName: tempResponse.uploadDocuments[0]?.FileName,
        });
        console.log(recipients, '002')

        // setEsignDetailModalOpen(true);
        console.log(recipients, '003')

        setIsLoading(false);
        console.log(recipients, '004')

      }
    } catch (error) {
      setIsLoading(false);
      console.log(error?.message, 'error?.message')
      //  let parsed;
      //  if(error?.message){
      //      parsed = JSON.parse(error?.message);
      //  }
      // console.log(parsed, 'parsed')
      // message.error(parsed?.error || error?.message)
    }
  };

  useEffect(()=>{
  handleEsignStatus()
    },[])

  return (
    <>
      <Tabs
        activeKey={activeKey}
        onChange={(key) => setActiveKey(key)}
        tabBarGutter={24}
        className='custom-tabs'
        tabBarStyle={{ marginBottom: '1rem' }}
      >
        <TabPane
          tab="View E-sign Status"
          className='!my-3 !text-lg '
          key="1"
        >
          {isLoading ? (
            <div className="!h-60 flex items-center justify-around w-2/6 mx-auto">
                <div className='text-gray-400'>Loading E-sign Status...</div>
             <div>
               <Spin spinning={isLoading}>
              </Spin>
             </div>
            </div>
          ) : (
            <EsignStatus signuluResponse={signuluResponse} id={id} />
          )}
        </TabPane>

        <TabPane
          tab='Send to Counter Party'
          className='!my-3 !text-lg '
          key="2"
        >
          <CounterParty onClose={() => setActiveKey(null)} id={id} />
        </TabPane>
      </Tabs>


    </>
  );
};

export default EsignAccordion;
